import axios from "axios";

  //const API_URL = "https://u2uprojects.coreaidataedge.com";
  // const API_URL = "http://localhost:5000";
const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://u2uprojects.coreaidataedge.com";
    
export const login = async (
  username,
  password
) => {
  return axios.post(
    `${API_URL}/login`,
    {
      username,
      password
    }
  );
};